import { FlexGrid, TypographyBody } from '@honeycomb/ui-core';
import React from 'react';
export function RoomPickerPanel({ title, subTitle, children, fieldId }) {
    return (React.createElement(FlexGrid, { container: true, flexWrap: "nowrap" },
        React.createElement(FlexGrid, { xs: "fill" },
            React.createElement(TypographyBody, { size: "s", component: "label", weight: "semiBold", htmlFor: fieldId }, title),
            React.createElement(TypographyBody, { size: "s", component: "div", color: "text.light" }, subTitle)),
        React.createElement(FlexGrid, { xs: "hold" }, children)));
}
